import { Component, Input, OnInit } from '@angular/core';
import {BlockSection, Section, TableSection} from "../../../models/surveyScheme/section";
import {CalendarTimeField, Field, LocationField, PhotoField, PlainTextField, SignatureField} from "../../../models/surveyScheme/field";

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit {

  // Использую any т.к. строгой типизации на уровне template нет
  // REMARK: Если использовать pipe/cast method то постоянно придётся его указывать при касте к нужному типу
  @Input() task: any;

  private collapsedSurvey: boolean = true;

  constructor() { }

  ngOnInit() {
  }

  private getMapLink(latitude: number, longitude: number): string {
    return `https://yandex.ru/maps/?pt=${longitude},${latitude}&z=12&l=map`;
  }

  private isBlock(section: Section): boolean {
    return section instanceof BlockSection;
  }

  private isTable(section: Section): boolean {
    return section instanceof TableSection;
  }

  private isTextField(field: Field): boolean {
    return field instanceof PlainTextField;
  }

  private isSignatureField(field: Field): boolean {
    return field instanceof SignatureField;
  }

  private isLocationField(field: Field): boolean {
    return field instanceof LocationField;
  }

  private isPhotoField(field: Field): boolean {
    return field instanceof PhotoField;
  }

  private isCalendarTimeField(field: Field): boolean {
    return field instanceof CalendarTimeField;
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/survey/survey.component.ts